function submitFormAjax(form) {
	$form = $(form);

	if (!$form.valid())
		return;

	data = $form.serialize();

	$.ajax({
		type: 'POST',
		url: $form.attr('action'),
		data: data,
		cache: false,
	}).done(function (data) {
		if (data.Type === "Html") {
			$form.replaceWith(data.HtmlBody);
			initValidationForm($form);
		} else if (data.Type === "Redirect") {
			window.location = data.RedirectUrl;
		}
	})
    .fail(function () {
    	alert("Произошла ошибка");
    });

	return false;
}